import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

import ContentCard from "../../../../components/misc/ContentCard";
import TextInput from "../../../../components/misc/TextInput";
import useRoutesHelper from "../../../../hooks/useRoutesHelper";
import CustomButton from "../../../../components/CustomButton";
import {
  getSelectProductWms,
  postEditProdusWms,
} from "../../../../redux/api/inventory.api";
import { clearSelectProductWms } from "../../../../redux/reducer/inventory.reducer";
import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";

interface initialValuesInterface {
  boxWidth: number | null;
  boxLength: number | null;
  boxHeight: number | null;
  boxWeigth: number | null;

  packWidth: number | null;
  packLength: number | null;
  packHeight: number | null;
  packWeigth: number | null;
}

const initialValues: initialValuesInterface = {
  boxWidth: null,
  boxLength: null,
  boxHeight: null,
  boxWeigth: null,

  packWidth: null,
  packLength: null,
  packHeight: null,
  packWeigth: null,
};

const productSchema = Yup.object({
  // pack start
  packWidth: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  packLength: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  packHeight: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  packWeigth: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  // pack end

  // box start
  boxWidth: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  boxLength: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  boxHeight: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  boxWeigth: Yup.number()
    .nullable()
    .required("Cantitatea trebuie specificata")
    .min(1, "Doar numere pozitive mai mari decat 0"),
  // box end
});

function NomenclatureEditPackage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { routeParams } = useRoutesHelper();

  const { idProdus } = routeParams || {};

  const [isLoading, setIsLoading] = useState(false);
  const [formikValues, setFormikValues] =
    useState<initialValuesInterface>(initialValues);

  const {
    inventory: {
      selectProductWms: { data: productDetailsData, isLoadingSelectProductWms },
    },
  } = useAppSelector((state) => ({
    inventory: state.inventory,
  }));

  useEffect(() => {
    if (idProdus) {
      dispatch(getSelectProductWms(idProdus));
    }
  }, [dispatch, idProdus]);

  useEffect(() => {
    return () => {
      dispatch(clearSelectProductWms());
    };
  }, [dispatch]);

  useEffect(() => {
    if (productDetailsData) {
      setFormikValues((prev) => ({
        ...prev,
        packWidth: productDetailsData?.latimeA || null,
        packLength: productDetailsData?.lungimeA || null,
        packHeight: productDetailsData?.inaltimeA || null,
        packWeigth: productDetailsData?.greutateA || null,
        boxWidth: productDetailsData?.latimeB || null,
        boxLength: productDetailsData?.lungimeB || null,
        boxHeight: productDetailsData?.inaltimeB || null,
        boxWeigth: productDetailsData?.greutateB || null,
      }));
    }
  }, [productDetailsData]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSaveProductDetails = async (value: initialValuesInterface) => {
    setIsLoading(true);

    const resultAction = await dispatch(
      postEditProdusWms({
        ...value,
        type: "package",
      }),
    );

    if (
      checkEndpointStatus(resultAction, postEditProdusWms) !==
      endpointStatus.pending
    ) {
      setIsLoading(false);
    }

    if (
      checkEndpointStatus(resultAction, postEditProdusWms) ===
      endpointStatus.fulfilled
    ) {
      navigate(-1);
    }
  };

  return (
    <ContentCard
      cardTitle="Editeaza detalii produs"
      cardHeaderClassName="text-center"
      isLoadingClassName="d-flex flex-column justify-content-center align-items-center vh-75"
      CardHeader={() => <></>}
      isLoading={isLoadingSelectProductWms}>
      <Formik
        enableReinitialize
        initialValues={formikValues}
        validationSchema={productSchema}
        onSubmit={handleSaveProductDetails}>
        {({
          isValid,
          errors,
          touched,
          getFieldProps,
          handleSubmit,
          isSubmitting,
        }) => (
          <form
            className="form w-100"
            onSubmit={handleSubmit}
            noValidate
            id="kt_login_signin_form">
            <ContentCard cardTitle="Ambalaj">
              <TextInput
                type="number"
                label="Latime"
                name="packWidth"
                error={errors["packWidth"]}
                touched={touched["packWidth"]}
                inputProps={getFieldProps("packWidth")}
              />
              <TextInput
                type="number"
                label="Lungime"
                name="packLength"
                error={errors["packLength"]}
                touched={touched["packLength"]}
                inputProps={getFieldProps("packLength")}
              />
              <TextInput
                type="number"
                label="Inaltime"
                name="packHeight"
                error={errors["packHeight"]}
                touched={touched["packHeight"]}
                inputProps={getFieldProps("packHeight")}
              />
              <TextInput
                type="number"
                label="Greutate"
                name="packWeigth"
                error={errors["packWeigth"]}
                touched={touched["packWeigth"]}
                inputProps={getFieldProps("packWeigth")}
              />
            </ContentCard>

            <ContentCard cardTitle="Bax">
              <TextInput
                type="number"
                label="Latime"
                name="boxWidth"
                error={errors["boxWidth"]}
                touched={touched["boxWidth"]}
                inputProps={getFieldProps("boxWidth")}
              />
              <TextInput
                type="number"
                label="Lungime"
                name="boxLength"
                error={errors["boxLength"]}
                touched={touched["boxLength"]}
                inputProps={getFieldProps("boxLength")}
              />
              <TextInput
                type="number"
                label="Inaltime"
                name="boxHeight"
                error={errors["boxHeight"]}
                touched={touched["boxHeight"]}
                inputProps={getFieldProps("boxHeight")}
              />
              <TextInput
                type="number"
                label="Greutate"
                name="boxWeigth"
                error={errors["boxWeigth"]}
                touched={touched["boxWeigth"]}
                inputProps={getFieldProps("boxWeigth")}
              />
            </ContentCard>

            <div className="d-flex justify-content-between">
              <CustomButton variant="outlined" onClick={handleGoBack}>
                Anuleaza
              </CustomButton>
              <CustomButton
                type="submit"
                variant="contained"
                loading={isSubmitting || isLoading}
                disabled={!isValid || isSubmitting}>
                Salveaza
              </CustomButton>
            </div>
          </form>
        )}
      </Formik>
    </ContentCard>
  );
}

export default NomenclatureEditPackage;
